




















import { defineComponent } from '@vue/composition-api'

export default defineComponent({
  name: 'Panel',

  props: {
    title: {
      type: String,
      default: null
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  }
})
